/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React, { ReactNode, useState } from 'react';
import LoadingButton from './LoadingButton'
import { ButtonProps } from 'reactstrap';

interface Props extends ButtonProps {
  children?: ReactNode;
  loadingText?: ReactNode;
  onClick: (e: React.MouseEvent) => any;
  testId?: string;
}

export function DownloadButton(props: Props) {

  const {
    onClick = async () => {},
    outline = false,
    color = 'link',
    block = false,
    children,
    ...rest
  } = props;

  const [isLoading, setLoading] = useState(false);

  const onClickHandler = async (e: React.MouseEvent) => {
    if (isLoading) {
      return;
    }
    setLoading(true);
    await onClick(e);
    setLoading(false)
  };

  return <LoadingButton
    loading={isLoading}
    outline={outline}
    color={color}
    block={block}
    onClick={onClickHandler} {...rest}>
    {children || <i className='px-1 fa fa-file-archive' />}
  </LoadingButton>

}
